import React from 'react';
import { GetFrontalClass } from './FadingArrow';

const StartOrderIndexItem = (props) => {
  return (
    <span
      onClick={() => { props.activateParticipant(props.id); }}
      onDoubleClick={() => { props.hide(props.id); }}
      className={"style-frontal style-order-list" + GetFrontalClass(props.completed, props.choose)}>
      {props.ident}
    </span>
  );
};

export default StartOrderIndexItem;
